import { MY_SOCIAL_MATCHES_KEY } from 'types/global'
import { AppState } from './reducers'

// user
export const selectUserIsLoggedIn = (state: AppState) => state.user.isLoggedIn
export const selectOwnTennisId = (state: AppState) => state.user.tennisId
export const selectCanRegister = (state: AppState) =>
  state.user.featuresConfig?.canRegisterThroughWalkUp
export const selectAccountAvatarUpdating = (state: AppState) => state.user.accountAvatarLoading

// profile
export const selectLoadedProfile = (state: AppState) => state.profile.loadedProfile
export const selectOwnProfile = (state: AppState) => state.profile.ownProfile
export const selectOwnProfileError = (state: AppState) => state.profile.ownProfileError
export const selectOwnProfileLoading = (state: AppState) => state.profile.ownProfileLoading
export const selectActiveProfileSection = (state: AppState) => state.profile.activeSection
export const selectProfileAvatarUpdating = (state: AppState) => state.profile.profileAvatarLoading

// psq
export const selectPsqLoading = (state: AppState) => state.psq.loading
export const selectPsqResults = (state: AppState) => state.psq.psqResults
export const selectPsqSubmitted = (state: AppState) => state.psq.psqSubmitted
export const selectPsqError = (state: AppState) => state.psq.error

// navbar
export const selectAppReady = (state: AppState) => state.user.appReady ?? false
export const selectHasPendingMatches = (state: AppState) =>
  !!state.socialMatches.totals[MY_SOCIAL_MATCHES_KEY]?.PENDING
